import * as React from 'react';
import {Col, Row} from 'react-bootstrap';
import {Field} from 'redux-form';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import {isNotFalse, isRequired} from '../../../../../../util/validators';

const TravellersConfirmation = ({channelKey}: { channelKey: string }) => {

  if (!['fst-b2c', 'tpl-b2c'].includes(channelKey)) {
    return null;
  }

  let permitVisaStatement = '(Please only tick if applicable) Holds a valid British residency permit or visa ' +
    'or are British members of Her Majesty\'s Armed Forces stationed overseas and is liable to pay taxes' +
    ' in England, Scotland, Wales or Northern Ireland';

  let visaCheckboxValidationRules = [];

  if (['tpl-b2c'].includes(channelKey)) {
    permitVisaStatement = 'Do all insured persons hold a valid British residency permit or visa or' +
      ' are British members of Her Majesty\'s Armed Forces stationed overseas and is liable to pay taxes in' +
      ' England, Scotland, Wales or Northern Ireland?';

    visaCheckboxValidationRules = [
      isRequired,
      isNotFalse,
    ];
  }

  return (
    <div className="traveller-confirmation-container">
      <h4>Eligibility</h4>
      {channelKey !== 'fst-b2c' ? (
        <div>
          <p className="py-15">Please tick to agree</p>
          <Row>
            <Col sm={12}>
              <Field
                id="main-home-uk"
                name="mainHomeUK"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Do all insured persons have their main home in and are resident of the UK (Including BFPO),
                Channel Islands or Isle of Man for at least 6 months?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="all-uk-visa"
                name="allUKVisa"
                type="checkbox"
                component={FieldFormControl}
                validate={visaCheckboxValidationRules}
              >
                <div />
                {permitVisaStatement}
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="in-uk-six-months"
                name="inUKSixMonths"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Have all insured persons been in the UK for a minimum of 6 months in the year prior to
                purchasing this policy?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="all-uk-ni-number"
                name="allUKNINumber"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Do all insured persons have a UK National Insurance number
                (Not applicable to Channel Island Residents or minors) and are registered with a medical
                practitioner the UK (home area) and are in the UK at present?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="trip-not-started"
                name="tripNotStarted"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Can you confirm for all insured persons, that your trip has not yet started and you are in the UK
                (Including BFPO), Channel Islands or Isle of Man at the time of purchasing this policy?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="start-end-in-uk"
                name="startEndInUK"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Can you confirm that for all insured persons that your trip/s will start and end in the UK
                (Including BFPO), Channel Islands or Isle of Man?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="not-against-doctors-advice"
                name="notAgainstDoctorsAdvice"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                Can you also confirm you and all insured persons are not travelling against the advice of a medical
                practitioner or would be if you had sought their advice before beginning the trip?
              </Field>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Field
                id="not-travelling-for-medical"
                name="notTravellingForMedical"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                And finally can you confirm that you and all insured persons are not travelling specifically to
                receive medical treatment during your trip or in the knowledge that you are likely to need treatment.
              </Field>
            </Col>
          </Row>
        </div>
      ) : (
        <div>
          <p className="py-15" style={{ paddingBottom: 0 }}>To be eligible for cover under this insurance you must
            comply with the following: </p>
          <p className="py-15" style={{ paddingBottom: 0 }}>You and all travellers:</p>
          <ul>
            <li>have been permanent residents of the UK (Including BFPO, Channel Islands and Isle of Man) for the
              last 6 months.
            </li>
            <li>are registered with a doctor in the UK, Channel Islands or Isle of Man.</li>
            <li>are in the UK at the time of buying this policy.</li>
            <li>are not travelling against medical advice or would be if you had sought their advice before the
              trip started.
            </li>
            <li>are not travelling to receive medical treatment</li>
          </ul>
          <p>The trip:</p>
          <ul>
            <li>Has not already started.</li>
            <li>Will start and end in the UK.</li>
          </ul>
          <Row style={{ paddingTop: 0 }}>
            <Col sm={12}>
              <Field
                id="eligibility"
                name="eligibility"
                type="checkbox"
                component={FieldFormControl}
                validate={[
                  isRequired,
                  isNotFalse,
                ]}
              >
                <div />
                I have read and agree with the above terms
              </Field>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default TravellersConfirmation;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/TravellersConfirmation/index.tsx